import React, { createContext, useCallback, useContext, useState } from 'react';

interface SidebarContextData {
  collapsed: boolean;
  toggleCollapsed: () => void;
  expand: () => void;
}

const SidebarContext = createContext<SidebarContextData>(
  {} as SidebarContextData,
);

const SidebarProvider: React.FC = ({ children }) => {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem('@TrenzoX:sidebarCollapsed') === 'true';
  });

  const toggleCollapsed = useCallback(() => {
    setCollapsed(state => {
      const newState = !state;
      localStorage.setItem('@TrenzoX:sidebarCollapsed', String(newState));
      return newState;
    });
  }, []);

  const expand = useCallback(() => {
    setCollapsed(false);
    localStorage.setItem('@TrenzoX:sidebarCollapsed', 'false');
  }, []);

  return (
    <SidebarContext.Provider value={{ collapsed, toggleCollapsed, expand }}>
      {children}
    </SidebarContext.Provider>
  );
};

function useSidebar(): SidebarContextData {
  const context = useContext(SidebarContext);

  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }

  return context;
}

export { SidebarProvider, useSidebar };
